export const FETCH_AGENT_SESSION_START = 'FETCH_AGENT_SESSION_START';
export const FETCH_AGENT_SESSION_SUCCESS = 'FETCH_AGENT_SESSION_SUCCESS';
export const FETCH_AGENT_SESSION_ERROR = 'FETCH_AGENT_SESSION_ERROR';
